import { Input } from '@ui/components';

import { Button } from '@ui/components';
import { FileUpIcon } from 'lucide-react';
import { FC, useCallback, useRef } from 'react';

interface ImportButtonProps {
  onImport: (file: File) => void;
}

export const ImportButton: FC<ImportButtonProps> = ({ onImport }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleImport = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file && onImport) {
        onImport(file);
        event.target.value = '';
      }
    },
    [onImport],
  );

  return (
    <>
      <Input
        ref={inputRef}
        accept=".csv, .xlsx, .xls"
        className="hidden"
        type="file"
        onChange={handleImport}
      />
      <Button
        type="button"
        className="h-8 px-2"
        variant="default"
        onClick={() => inputRef.current?.click()}
      >
        <FileUpIcon className="mr-1.5 size-4" />
        Import
      </Button>
    </>
  );
};
